<template>
  <FrameFormDesigner/>
</template>

<script>

export default {
  name: "MyDemo",
}
</script>

<style scoped>

</style>